import { render } from "./StepDetails.vue?vue&type=template&id=f38af49a&scoped=true"
import script from "./StepDetails.vue?vue&type=script&lang=js"
export * from "./StepDetails.vue?vue&type=script&lang=js"

import "./StepDetails.vue?vue&type=style&index=0&id=f38af49a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38af49a"]])

export default __exports__